export default "__VITE_ASSET__BfkUnsks__"